/* eslint-disable react/prop-types */
import { useIntl } from '@leagueplatform/locales';
import { ICONS, Icon } from '@leagueplatform/ui-kit';
import {
  Button,
  GDSStyleObject,
  Modal,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';
// eslint-disable-next-line @leagueplatform/prevent-import-from-dist
import {
  GDSButtonPriority,
  GDSButtonSize,
} from '@leagueplatform/genesis-core/dist/components/button/button';

interface ModalActionButtonProps {
  actionType: 'close' | 'submit' | 'cancel';
  onClick?: () => void;
  labelId: string;
  isMobile?: boolean;
  cssStyle?: GDSStyleObject;
  isDestructive?: boolean;
}

export const ModalActionButton: React.FC<ModalActionButtonProps> = ({
  actionType,
  onClick,
  labelId,
  isMobile = false,
  cssStyle,
  isDestructive = false,
}) => {
  const { formatMessage } = useIntl();

  // Determine button settings based on actionType
  const settings = {
    close: {
      priority: 'tertiary',
      icon: ICONS.CLOSE,
      size: 'small',
    },
    submit: {
      priority: 'primary',
      size: isMobile ? 'large' : 'medium',
    },
    cancel: {
      priority: 'tertiary',
      size: isMobile ? 'large' : 'medium',
    },
  }[actionType];

  return (
    // @ts-ignore
    <Modal.Close>
      <Button
        type={actionType === 'submit' ? 'submit' : 'button'}
        onClick={onClick}
        priority={settings.priority as GDSButtonPriority}
        size={settings.size as GDSButtonSize}
        icon={settings.icon ? 'tinyClose' : undefined}
        hideLabel={actionType === 'close'}
        css={cssStyle}
        destructive={isDestructive}
      >
        {actionType === 'close' ? (
          <VisuallyHidden>{formatMessage({ id: labelId })}</VisuallyHidden>
        ) : (
          formatMessage({ id: labelId })
        )}
        {actionType === 'close' && (
          <Icon icon={settings.icon as any} size={16} aria-hidden="true" />
        )}
      </Button>
    </Modal.Close>
  );
};
